// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import './addRemark.scss'
import { PrimaryButton, SecondaryButton } from 'ui_kit_qmd'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AddRemark = ({ remarkValue, onChange, onCancel, onRemarkAdd, isEditMode, onEditRemark }) => {
  const [initialRemarkValue, setInitialRemarkValue] = useState('')

  useEffect(() => {
    setInitialRemarkValue(remarkValue)
  }, [])

  const onPrimaryButtonPressed = () => {
    if (isEditMode) {
      if (initialRemarkValue !== remarkValue) {
        onEditRemark?.()
      } else {
        onCancel?.()
      }
    } else {
      onRemarkAdd?.()
    }
  }

  return (
    <section className='textarea-container'>
      <label htmlFor='reamrkText'>
        <header className='textarea-header'>{isEditMode ? 'Edit visit remark' : 'Add visit remark'}</header>
        <textarea
          value={remarkValue}
          onChange={onChange}
          autoComplete='off'
          placeholder='Type something...'
          className='textarea-remark'
          name='remark'
          id='reamrkText'
        />
      </label>
      <div className='textarea-remark-actions'>
        <SecondaryButton btnText='Cancel' onPress={onCancel} />
        <PrimaryButton btnText='Save' onPress={onPrimaryButtonPressed} />
      </div>
    </section>
  )
}
